// /opt/ptg01-v1/front-simulation/app/LayoutRouter.tsx
// Garde d'authentification admin (portée depuis front-admin le 2026-08-29 : jusque-là l'outil
// commercial était accessible sans aucune authentification et listait les PII de tous les prospects).
// Les pages /auth/* restent publiques ; tout le reste exige un admin connecté (cookie nx_token).
'use client';

import { usePathname } from 'next/navigation';
import AdminAuthGuard from '../components/AdminAuthGuard';

export default function LayoutRouter({ children }: { children: React.ReactNode }) {
    const pathname = usePathname();
    if (pathname.startsWith('/auth')) return <>{children}</>;
    return <AdminAuthGuard>{children}</AdminAuthGuard>;
}
